export default __webpack_public_path__ + "static/architecture-banner-1c98a04a299905c0daa44d34a01e09fb.jpg";